<template>
  <PanelPrint
    class="panel-print-alarm-level"
    :title="panelTitle"
  >
    <div class="panel-print-alarm-level__table-container">
      <div class="panel-print-alarm-level__table">
        <alarm-level-params-tab
          :items="gasesItems"
          :fields="paramsTabTableGasFields"
          :card-title="gasCardTitle"
          />
      </div>
      <div class="panel-print-alarm-level__table">
        <alarm-level-params-tab
          class="panel-print-alarm-level__margin"
          :items="ratesItems"
          :fields="paramsTabTableRatesFields"
          :card-title="ratesCardTitle"
          />
      </div>
    </div>
  </PanelPrint>
</template>

<script>
import IndividualAnalysisService from '@/domain/services/installation/engineering/chromatography/individualAnalysis';
import PanelPrint from './PanelPrint';
import AlarmLevelParamsTab from '../AlarmLevelParamsTab';

export default {
  name: 'AlarmeLevelParametersTable',
  props: {
    assetModuleId: String,
    sampleId: String,
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PanelPrint,
    AlarmLevelParamsTab,
  },
  data: () => ({
    alarmLevels: {
      gases: [],
      rates: [],
    },
  }),
  computed: {
    paramsTabTableGasFields() {
      return [
        {
          key: 'gas',
          label: this.$t('engineering.chromatography.methods-and-diagnostics.alarm-levels.gas'),
        },
        {
          key: 'value',
          label: this.$t('engineering.chromatography.methods-and-diagnostics.alarm-levels.gas-fields.sample-value'),
        },
        {
          key: 'highLimit',
          label: this.$t('engineering.chromatography.methods-and-diagnostics.alarm-levels.gas-fields.high-value'),
        },
        {
          key: 'veryHighLimit',
          label: this.$t('engineering.chromatography.methods-and-diagnostics.alarm-levels.gas-fields.very-high-value'),
        },
      ];
    },
    paramsTabTableRatesFields() {
      return [
        {
          key: 'gas',
          label: this.$t('engineering.chromatography.methods-and-diagnostics.alarm-levels.gas'),
        },
        {
          key: 'value',
          label: this.$t('engineering.chromatography.methods-and-diagnostics.alarm-levels.rates-fields.sample-value'),
        },
        {
          key: 'highLimit',
          label: this.$t('engineering.chromatography.methods-and-diagnostics.alarm-levels.rates-fields.high-value'),
        },
        {
          key: 'veryHighLimit',
          label: this.$t('engineering.chromatography.methods-and-diagnostics.alarm-levels.rates-fields.very-high-value'),
        },
      ];
    },
    panelTitle() {
      return this.$t('engineering.chromatography.methods-and-diagnostics.alarm-levels-parameters');
    },
    gasesItems() {
      return this.alarmLevels.gases.map(alarm => this.paramsTabTableItems(alarm));
    },
    ratesItems() {
      return this.alarmLevels.rates.map(alarm => this.paramsTabTableItems(alarm));
    },
    gasCardTitle() {
      return this.$t('engineering.chromatography.methods-and-diagnostics.alarm-levels.gases');
    },
    ratesCardTitle() {
      return this.$t('engineering.chromatography.methods-and-diagnostics.alarm-levels.rates');
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    formatTableItemValue(value) {
      return value === undefined ? '--' : value;
    },
    loadData() {
      this.$emit('update:loading', true);
      IndividualAnalysisService
        .getAlarmLevelParams(this.assetModuleId, this.sampleId)
        .then((response) => {
          this.alarmLevels = response;
        })
        .finally(() => {
          this.$emit('update:loading', false);
        });
    },
    paramsTabTableItems(alarm) {
      return {
        ...alarm,
        gas: this.$t(`engineering.chromatography.chemical-elements.${alarm.gas.toLowerCase()}`),
        value: this.formatTableItemValue(alarm.value),
        highLimit: this.formatTableItemValue(alarm.highLimit),
        veryHighLimit: this.formatTableItemValue(alarm.veryHighLimit),
      };
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"
  @import "src/styles/defaults/mobile-first"


  .panel-print-alarm-level
    &__table-container
      display: flex
      flex-direction: row
      flex-wrap: wrap
    &__table
      position: relative
      width: 100%
      +media-min-lg()
        width: 50%
    ::v-deep .table
      background: none
    ::v-deep .alarm-level-params-tab .table thead tr th
      border: 1px solid $color-gray-intermediary
      background: none
    ::v-deep .alarm-level-params-tab .table tbody tr:first-child td
      border-top: none !important
    ::v-deep .alarm-level-params-tab .table thead tr:last-child th
      border-bottom: none
    ::v-deep .table td
      border: 1px solid $color-gray-intermediary !important
    ::v-deep .alarm-level-params-tab .table thead tr th,
    ::v-deep .alarm-level-params-tab .table tr td
      border-right: 1px solid $color-gray-intermediary !important
      border-left: 1px solid $color-gray-intermediary !important
    ::v-deep .alarm-level-params-tab .table thead tr th.alarm-level-params-tab__table-header-gap
      background: none !important
      border: none !important
      border-left: none !important
  @media print
    .panel-print-alarm-level
      ::v-deep .alarm-level-params-tab .table thead tr th
        background: none !important
      &__table
        width: 100%
      &__margin
        margin-top: 0
</style>
